import { useState } from 'react';

import { Button, Input, Form } from 'antd';
import moment from 'moment';

import { ErrorResponse } from 'utils/types';
import notifier from 'utils/notifier';

import FloatLabel from 'components/Common/FloatLabel';
import DatePickerLocalised from 'components/Common/DatePickerLocalised';

import './index.scss';


interface SubmittedBatchClaimsFormProps {
  isFetchingSubmitted: boolean,
  getSubmitted(searchObject: Object): any, //={props.getSubmitted}
  setDataSource(data: any[]): void,//={setSubmittedClaims}
};

const SubmittedBatchClaimsForm = (props: SubmittedBatchClaimsFormProps) => {

  const [form] = Form.useForm();
  const [submittedDateFrom, setSubmittedDateFrom] = useState('');
  const [submittedDateTo, setSubmittedDateTo] = useState('');

  const DEFAULT_SEARCH_VALUES = {
    BatchClaimNo: '',
    StatusValue: '',
    MemberId: '',
    UserId: sessionStorage.getItem('user_id'),
  };

  const onSearch = () => {
    form.validateFields().then(values => {
      let formData = {
        BatchClaimNo: values.referenceNum !== '' ? values.referenceNum : null,
        SubmittedDateFrom: submittedDateFrom !== '' ? submittedDateFrom : null,
        SubmittedDateTo: submittedDateTo !== '' ? submittedDateTo : null,
        UserId: sessionStorage.getItem('user_id'),
      };
      return props.getSubmitted(formData)
        .then((response: any) => {
          if (response.length === 0) notifier.error('There were no results for this search. Please check the fields and try again.');
          props.setDataSource(response);
        })
        .catch((err: ErrorResponse) => {
          notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
        });
    })
  };

  const onReset = () => {
    props.setDataSource([]);
    form.resetFields();
    setSubmittedDateFrom('');
    setSubmittedDateTo('');
  };

  return (
    <Form
      form={form}
      name="submitBatchClaimSearchForm'"
      onFinish={onSearch}
    >
      <div className="member-search row flex-lg-wrap justify-content-start mb-3 ml-0">
        <div className="col-lg-6">
          <FloatLabel
            label="Reference No.:"
            name="referenceNum"
            form={form}
          >
            <Input />
          </FloatLabel>
        </div>

        <div className="col-lg-6">
          <FloatLabel
            label="Submitted From (MM/DD/YYYY)"
            name="submittedDateFrom"
            value={submittedDateFrom}
            form={form}
            validateTrigger={['onChange']}
            rules={[
              () => ({
                async validator(_: any, __: any) {
                  const invalidDate = () => submittedDateFrom && (!moment(submittedDateFrom).isValid() || moment(submittedDateFrom).year() < 1900 || !submittedDateFrom.match(/^\d{2}\/\d{2}\/\d{4}$/));

                  if (invalidDate()) {
                    return Promise.reject(new Error('Invalid Date'));
                  }

                  return Promise.resolve();
                },
              })
            ]}
          >
          <DatePickerLocalised
            date={submittedDateFrom}
            setDate={setSubmittedDateFrom}
          />
          </FloatLabel>
        </div>

        <div className="col-lg-6">
          <FloatLabel
            label="Submitted To (MM/DD/YYYY)"
            name="submittedDateTo"
            value={submittedDateTo}
            form={form}
            validateTrigger={['onChange']}
            rules={[
              () => ({
                async validator(_: any, __: any) {
                  const invalidDate = () => submittedDateTo && (!moment(submittedDateTo).isValid() || moment(submittedDateTo).year() < 1900 || !submittedDateTo.match(/^\d{2}\/\d{2}\/\d{4}$/));

                  if (invalidDate()) {
                    return Promise.reject(new Error('Invalid Date'));
                  }

                  return Promise.resolve();
                },
              })
            ]}
          >
          <DatePickerLocalised
            date={submittedDateTo}
            setDate={setSubmittedDateTo}
          />
          </FloatLabel>
        </div>

        <div className="col-lg-6 mt-2">
          <Form.Item>
            <div className="d-flex justify-content-end">
              <Button type="primary" style={{ width: "50%" }} htmlType={'submit'} loading={props.isFetchingSubmitted}>SEARCH</Button>
              <Button type="default" style={{ width: "50%" }} onClick={onReset}>RESET</Button>
            </div>
          </Form.Item>
        </div>
      </div>
    </Form>
  );
}

export default SubmittedBatchClaimsForm;